import { defineMessages } from 'react-intl';

export default defineMessages({
    hidePackageCoverages: {
        id: 'policy.common.component.farm-policy-info.hide vehicle coverages',
        defaultMessage: 'Hide Package Coverages'
    },
    showPackageCoverages: {
        id: 'policy.common.component.farm-policy-info.show vehicle coverages',
        defaultMessage: 'Show Package Coverages'
    },
    package: {
        id: 'policy.common.component.farm-policy-info.Package',
        defaultMessage: 'Package'
    },
    primary: {
        id: 'policy.common.component.farm-policy-info.Primary',
        defaultMessage: 'Primary'
    },
    supremeAgribusiness: {
        id: 'policy.common.component.farm-policy-info.Supreme Agribusiness',
        defaultMessage: 'Supreme Agribusiness'
    },
    nonPackagedAgribusiness: {
        id: 'policy.common.component.farm-policy-info.Non Packaged Agribusiness',
        defaultMessage: 'Non Packaged Agribusiness'
    },
    PackageType: {
        id: 'policy.common.component.farm-policy-info.Package Type',
        defaultMessage: 'Package Type'
    },
    farmProgramType: {
        id: 'policy.common.component.farm-policy-info.Farm Program Type',
        defaultMessage: 'farmProgramType'
    },
    taxExempt: {
        id: 'policy.common.component.farm-policy-info.Tax Exempt',
        defaultMessage: 'Tax Exempt'
    },
    fireGrade: {
        id: 'policy.common.component.farm-policy-info.Fire Grade',
        defaultMessage: 'Fire Grade'
    },
    discounts: {
        id: 'policy.common.component.farm-policy-info.Discounts',
        defaultMessage: 'Discounts'
    },
    programCoveragesEndorsements: {
        id: 'policy.common.component.farm-policy-info.Program Coverages/ Endorsements',
        defaultMessage: 'Program Coverages/ Endorsements'
    },
    limit: {
        id: 'policy.common.component.farm-policy-info.Limit',
        defaultMessage: 'Limit'
    },
    deductible: {
        id: 'policy.common.component.farm-policy-info.Deductible',
        defaultMessage: 'Deductible'
    },
    businessInterruption: {
        id: 'policy.common.component.farm-policy-info.Business Interruption',
        defaultMessage: 'Business Interruption'
    },
    coverage: {
        id: 'policy.common.component.farm-policy-info.Coverage',
        defaultMessage: 'Coverage'
    },
    equipmentandMachinery: {
        id: 'policy.common.component.farm-policy-info.Equipment and Machinery',
        defaultMessage: 'Equipment and Machinery'
    },
    buildings: {
        id: 'policy.common.component.farm-policy-info.Buildings',
        defaultMessage: 'Buildings'
    },
    produce: {
        id: 'policy.common.component.farm-policy-info.Produce',
        defaultMessage: 'Produce'
    },
    produceDetails: {
        id: 'policy.common.component.farm-policy-info.Produce Details',
        defaultMessage: 'Produce Details'
    },
    livestock: {
        id: 'policy.common.component.farm-policy-info.Livestock',
        defaultMessage: 'Livestock'
    },
    classification: {
        id: 'policy.common.component.farm-policy-info.Classification',
        defaultMessage: 'Classification'
    },
    value: {
        id: 'policy.common.component.farm-policy-info.Value',
        defaultMessage: 'Value'
    },
    coveragesEmpty: {
        id: 'policy.common.component.farm-policy-info.CoveragesEmpty',
        defaultMessage: 'CoveragesEmpty'
    },
    farmExtensions: { 
        id: 'policy.common.component.cp-coverages-component.Farm Extensions of Coverage',
        defaultMessage: 'Farm Extensions of Coverage'
    },
    hideExtension: {
        id: 'policy.common.component.farm-policy-info.hide vehicle Extension',
        defaultMessage: 'Hide Package Extension'
    },
    showExtension: {
        id: 'policy.common.component.farm-policy-info.show vehicle Extension',
        defaultMessage: 'Show Package Extension'
    },

});
